class AgeVerification extends Drawer {
    constructor() {
        super();
        this.approveButton = this.querySelector('[yes-button]');

        if (this.approveButton) {
            this.approveButton.addEventListener('click', this.verifyAge.bind(this));
        }
    }

    verifyAge(e) {
        e.preventDefault();
        this.persistVerification();
        HELPER_UTIL.dispatchCustomEvent(
            _EVENT_HELPER.hideDrawer,
            this,
            {
                drawerType: 'age-popup',
            }
        );

    }


    persistVerification() {
        try {
            localStorage.setItem('age-verified', 'true');
        } catch (error) {
            // The persistent cookie below remains the fallback when storage is blocked.
        }

        this.setCookie('age-verified', 'true', 400);
    }

    setCookie(name, value, days) {
        const maxAge = days * 24 * 60 * 60;
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';

        document.cookie = `${name}=${value}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
    }

    getCookie(name) {
        const nameEQ = name + '=';
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length);
            }
        }

        return null;
    }

    getStoredVerification() {
        try {
            return localStorage.getItem('age-verified');
        } catch (error) {
            return null;
        }
    }

    connectedCallback() {
        if (
            this.getCookie('age-verified') === 'true' ||
            this.getStoredVerification() === 'true'
        ) {
            // Migrate the theme's former session-only cookie and refresh both stores.
            this.persistVerification();
            return;
        }

        HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.showDrawer, this, {
            drawerType: 'age-popup',
        });
    }
}

customElements.define('age-verification', AgeVerification);

